import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "accommodation-nearby my-4" };
const _hoisted_2 = { class: "carousel" };
const _hoisted_3 = {
    key: 0,
    class: "loading-state"
};
const _hoisted_4 = {
    key: 1,
    class: "error-state"
};
const _hoisted_5 = {
    key: 3,
    class: "empty-state"
};
const _hoisted_6 = {
    key: 4,
    class: "scroll-indicator"
};
const _hoisted_7 = { class: "scroll-track" };
const _hoisted_8 = {
    class: "scroll-progress",
    ref: "scrollProgress"
};
const _hoisted_9 = { class: "scroll-arrows" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_AccommodationCard = _resolveComponent("AccommodationCard");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "mb-3" }, "Otros hoteles cercanos", -1)),
        _createElementVNode("div", _hoisted_2, [
            ($setup.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[8] || (_cache[8] = [
                    _createElementVNode("div", { class: "spinner" }, null, -1),
                    _createElementVNode("p", null, "Cargando hoteles...", -1)
                ])))
                : ($setup.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
                        _createElementVNode("p", null, _toDisplayString($setup.error), 1),
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => ($setup.fetchAccommodations && $setup.fetchAccommodations(...args))),
                            class: "retry-btn"
                        }, "Reintentar")
                    ]))
                    : ($setup.accommodations.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "accommodations-grid",
                            ref: "track",
                            onMousedown: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => ($setup.handleMouseDown && $setup.handleMouseDown(...args))),
                            onScroll: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => ($setup.updateScrollProgress && $setup.updateScrollProgress(...args))),
                            onTouchstart: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => ($setup.handleTouchStart && $setup.handleTouchStart(...args))),
                            onTouchmove: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => ($setup.handleTouchMove && $setup.handleTouchMove(...args))),
                            onTouchend: _cache[5] || (_cache[5] =
                                //@ts-ignore
                                (...args) => ($setup.handleTouchEnd && $setup.handleTouchEnd(...args)))
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.accommodations, (accommodation) => {
                                return (_openBlock(), _createBlock(_component_AccommodationCard, {
                                    key: accommodation.id,
                                    image: $setup.getMainImage(accommodation),
                                    title: accommodation.title,
                                    location: accommodation.location,
                                    price: $setup.formatPrice(accommodation.price_per_night),
                                    description: accommodation.description,
                                    badge: accommodation.badge,
                                    to: { name: 'AccommodationDetail', params: { id: accommodation.id } }
                                }, null, 8, ["image", "title", "location", "price", "description", "badge", "to"]));
                            }), 128))
                        ], 544))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "fas fa-bed" }, null, -1),
                            _createElementVNode("p", null, "No hay hoteles disponibles en este momento", -1)
                        ]))),
            ($setup.accommodations.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, null, 512)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("button", {
                            class: "scroll-arrow scroll-left",
                            onClick: _cache[6] || (_cache[6] = ($event) => ($setup.scroll(-1)))
                        }, _cache[11] || (_cache[11] = [
                            _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
                        ])),
                        _createElementVNode("button", {
                            class: "scroll-arrow scroll-right",
                            onClick: _cache[7] || (_cache[7] = ($event) => ($setup.scroll(1)))
                        }, _cache[12] || (_cache[12] = [
                            _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                        ]))
                    ])
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
